import React, { useEffect, useState } from "react";
import { MdOutlineFilterList } from "react-icons/md";
import { ApiPaths } from "../../Config/ApiPath";
import Loader from "../../Components/Loader/Loader";
import PaginationComponent from "./../../Components/PaginationControls/PaginationControls";
import useAxiosHelper from "../../Common/AxiosHelper";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { BasicInfo } from "../../Config/BasicInfo";
import moment from "moment";
import Change from "../../Common/StringToSub";
import { Calendar, Clock, Package, Check, ArrowLeft } from "lucide-react";

const SwappingHistory = ({ refresh, onBack }) => {
  const [filterVisiblity, setFilterVisiblity] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paymentTransaction, setPaymentTransaction] = useState();
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limitFilter, setLimitFilter] = useState(20);
  const { AxiosGet } = useAxiosHelper();
  const [withdrawType, setWithdrawType] = useState("coin_convert");
  const incomeData = useSelector((state) => state.incomeData.incomeWallet);
  const [companyData, setCompanyData] = useState([]);
  const [currentTime, setCurrentTime] = useState(new Date());
  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const [search, setSearch] = useState({
    startDate: "",
    endDate: "",
  });
  var x = 0;
  useEffect(() => {
    if (x === 0) {
      FetchData();
      CompanyInfo();
      x++;
    }
  }, [refresh]);

  async function CompanyInfo() {
    try {
      const data = localStorage.getItem("companyData");
      setCompanyData(JSON.parse(data));
    } catch (error) {
      BasicInfo.isDebug && console.log(error);
    }
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setSearch((prev) => ({ ...prev, [name]: value }));
  };

  const AddFilter = () => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    FetchData(queryParams);
  };

  const FetchData = async (page = currentPage) => {
    try {
      setLoading(true);
      const filteredSearch = Object.fromEntries(
        Object.entries(search).filter(([key, value]) => value !== "")
      );
      const filters = {
        source: withdrawType,
        ...filteredSearch,
      };
      const queryParams = {
        page,
        limit: limitFilter,
        ...filters,
      };
      const response = await AxiosGet(
        `${ApiPaths.getPaymentTransaction}?${new URLSearchParams(
          queryParams
        ).toString()}`
      );
      BasicInfo.isDebug && console.log("withdraw history", response);
      setPaymentTransaction(response?.data || []);
      setTotalPages(response?.totalPages || 1);
    } catch (error) {
      console.error("Error fetching payment transactions:", error);
    } finally {
      setLoading(false);
    }
  };
  function resetData() {
    setSearch({
      startDate: "",
      endDate: "",
    });
    setCurrentPage(1);
    setLimitFilter(20);
  }
  useEffect(() => {
    if (search.startDate === "" && search.endDate === "") {
      FetchData();
    }
  }, [search]);

  useEffect(() => {
    FetchData();
  }, [withdrawType]);

  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };
  return (
    <>
      {loading ? <Loader /> : null}
      <section className="dashboard">
        <div className="incomeSelectBox">
          {/* <div>
          <Col lg="2" md="4" xs="12">
            <select
              value={withdrawType}
              onChange={(e) => setWithdrawType(e.target.value)}
            >
              <option value="withdrawal">Withdrawal</option>
              <option value="principal_withdrawal">Principal Withdrawal</option>
            </select>
          </Col>
          </div> */}

          <p
            onClick={onBack}
            style={{
              color: "var(--textColor)",
              opacity: "0.8",
              cursor: "pointer",
            }}
          >
            {" "}
            <ArrowLeft size={16} /> Back
          </p>
          <button onClick={() => setFilterVisiblity(!filterVisiblity)}>
            {filterVisiblity ? "Hide Filters" : "Show Filters"}
            <i>
              {" "}
              <MdOutlineFilterList />
            </i>{" "}
          </button>
        </div>
        {filterVisiblity ? (
          <section className="filtersection inputPrimary">
            <Row>
              <Col lg="2" md="4" xs="12">
                <input
                  type="date"
                  placeholder="From Date"
                  name="startDate"
                  value={search.startDate}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <input
                  type="date"
                  placeholder="End Date"
                  name="endDate"
                  value={search.endDate}
                  onChange={handleChange}
                />
              </Col>
              <Col lg="2" md="4" xs="12">
                <div>
                  <select
                    name=""
                    value={limitFilter}
                    onChange={handleLimitChange}
                  >
                    <option value="">--All--</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </select>
                </div>
              </Col>
              <Col lg="2" md="4" xs="6">
                <button onClick={AddFilter}>Search</button>
              </Col>
              <Col lg="2" md="4" xs="6">
                <button onClick={() => resetData()}>Reset</button>
              </Col>
            </Row>
          </section>
        ) : null}
        <div className="incomeHistoryTableSection">
          <h2 className="incomeBreakdownTitle">Withdrawal History</h2>
          <div className="withdrawal-list">
            {paymentTransaction != null &&
            Array.isArray(paymentTransaction) &&
            paymentTransaction.filter((x) => x?.status !== 2).length > 0 ? (
              paymentTransaction
                .filter((x) => x?.status !== 2)
                .map((x, i) => (
                  <div className="withdrawal-card" key={x?._id || i}>
                    <div className="withdrawal-card-row">
                      <div className="withdrawal-amount">
                        <span className="withdrawal-label">Requested:</span>
                        <span className="withdrawal-value">
                          {companyData?.token_sign}
                          {parseFloat(x?.amount).toFixed(2)}
                        </span>
                      </div>
                      <div className="withdrawal-status">
                        {x?.status == "0" ? (
                          <span className="status-badge pending">Pending</span>
                        ) : x?.status == "1" ? (
                          <span className="status-badge success">Success</span>
                        ) : (
                          <span className="status-badge rejected">
                            Rejected
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="withdrawal-card-row">
                      <div>
                        <span className="withdrawal-label">Admin Fee:</span>
                        <span className="withdrawal-value">
                          {companyData?.token_sign}
                          {parseFloat(x?.TDS).toFixed(2)}
                        </span>
                      </div>
                    </div>
                    <div className="withdrawal-card-row">
                      <div
                        className="withdrawal-label"
                        style={{ fontSize: "12px" }}
                      >
                        {moment(x?.time).fromNow()}
                      </div>
                      <div>
                        <span className="withdrawal-label">Received:</span>
                        <span className="withdrawal-value">
                          {companyData?.token_sign}
                          {parseFloat(x?.withdrawal_amount).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </div>
                ))
            ) : (
              <p>No history yet</p>
            )}
          </div>
          {paymentTransaction != null && (
            <PaginationComponent
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePagination}
            />
          )}
        </div>
      </section>
    </>
  );
};

export default SwappingHistory;
